<section class="main-container col2-right-layout">
    <div class="main container">
        <div class="row">
<section class="col-main col-sm-10 col-xs-12 wow bounceInUp animated animated animated">
                <router-outlet></router-outlet>
            </section>
            <aside class="col-right sidebar col-sm-2 col-xs-12 wow bounceInUp animated animated animated">
                <div class="block block-account">
                    <div class="block-title">
                        Admin Account
                    </div>
                    <div class="block-content">
                        <ul>
                            <li>
                                <a [routerLink]="['/admin', 'dashboard']">
                                    <span>Dashboard</span>
                                </a>
                            </li>

                            <li class="nav-group">
                                <a class="nav-group-header" (click)="toggleGroup('offers-orders')">
                                    <span>Offers & Orders</span>
                                    <i class="fa" [ngClass]="{'fa-chevron-down': !isGroupOpen('offers-orders'), 'fa-chevron-up': isGroupOpen('offers-orders')}"></i>
                                </a>
                                <ul class="nav-group-items" [class.show]="isGroupOpen('offers-orders')">
                                    <li><a [routerLink]="['offers']" class="nav-link"><span>Offers</span></a></li>
                                    <li><a [routerLink]="['/admin', 'requested-products']"><span>Requested Products</span></a></li>
                                    <li><a [routerLink]="['/admin', 'orders']" class="nav-link"><span>Orders</span></a></li>
                                    <li><a [routerLink]="['/admin', 'subscriptions']" class="nav-link"><span>Subscriptions</span></a></li>
                                    <li><a [routerLink]="['/admin', 'payments']" class="nav-link"><span>Payments</span></a></li>
                                    <li><a [routerLink]="['/admin', 'taxonomies']" class="nav-link"><span>Taxonomies</span></a></li>
                                </ul>
                            </li>

                            <li class="nav-group">
                                <a class="nav-group-header" (click)="toggleGroup('profiles')">
                                    <span>Profiles Management</span>
                                    <i class="fa" [ngClass]="{'fa-chevron-down': !isGroupOpen('profiles'), 'fa-chevron-up': isGroupOpen('profiles')}"></i>
                                </a>
                                <ul class="nav-group-items" [class.show]="isGroupOpen('profiles')">
                                    <li><a [routerLink]="['/admin','sellers']"><span>Sellers</span></a></li>
                                    <li><a [routerLink]="['/admin','logistic-partners']"><span>Logistic Partners</span></a></li>
                                    <li><a [routerLink]="['/admin','users']"><span>Users</span></a></li>
                                </ul>
                            </li>

                            <li class="nav-group">
                                <a class="nav-group-header" (click)="toggleGroup('contents')">
                                    <span>Contents</span>
                                    <i class="fa" [ngClass]="{'fa-chevron-down': !isGroupOpen('contents'), 'fa-chevron-up': isGroupOpen('contents')}"></i>
                                </a>
                                <ul class="nav-group-items" [class.show]="isGroupOpen('contents')">
                                    <li><a [routerLink]="['/admin', 'pages']" class="nav-link"><span>Pages</span></a></li>
                                    <li><a [routerLink]="['/admin','blog-posts']"><span>Blog Posts</span></a></li>
                                    <li><a [routerLink]="['/admin','team']"><span>Our Team</span></a></li>
                                    <li><a [routerLink]="['/admin','clients-partners']"><span>Clients and Partners</span></a></li>
                                    <li><a [routerLink]="['/admin','testimonials']"><span>Testimonials</span></a></li>
                                    <li><a [routerLink]="['/admin','jobs']"><span>Career</span></a></li>
                                    <li><a [routerLink]="['/admin','ad-banners']"><span>Ad Banners</span></a></li>
                                </ul>
                            </li>

                            <li class="nav-group">
                                <a class="nav-group-header" (click)="toggleGroup('crm')">
                                    <span>CRM</span>
                                    <i class="fa" [ngClass]="{'fa-chevron-down': !isGroupOpen('crm'), 'fa-chevron-up': isGroupOpen('crm')}"></i>
                                </a>
                                <ul class="nav-group-items" [class.show]="isGroupOpen('crm')">
                                    <li><a [routerLink]="['/admin', 'crm-templates']"><span>{{'Templates' | translate}}</span></a></li>
                                    <li><a [routerLink]="['/admin', 'outbox']"><span>{{'Outbox' | translate}}</span></a></li>
                                </ul>
                            </li>

                            <li class="nav-group">
                                <a class="nav-group-header" (click)="toggleGroup('settings')">
                                    <span>Settings</span>
                                    <i class="fa" [ngClass]="{'fa-chevron-down': !isGroupOpen('settings'), 'fa-chevron-up': isGroupOpen('settings')}"></i>
                                </a>
                                <ul class="nav-group-items" [class.show]="isGroupOpen('settings')">
                                    <li><a [routerLink]="['/admin', 'pricing']"><span>Pricing</span></a></li>
                                    <li><a [routerLink]="['/admin', 'measurement-units']"><span>Measurement Units</span></a></li>
                                    <li><a [routerLink]="['/admin', 'product-conditions']"><span>Product Conditions</span></a></li>
                                    <li><a [routerLink]="['/admin', 'product-categories']"><span>Product Categories</span></a></li>
                                    <li><a [routerLink]="['/admin', 'products']" class="nav-link"><span>Products</span></a></li>
                                    <li><a [routerLink]="['/admin','sectors']"><span>Sectors</span></a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </aside>
        </div>
    </div>
</section>